const productThumbs = document.querySelector('.product__thumbnails');
const productGallerySelector = '.product__gallery:not(.swiper-initialized)';
const productThumbnailsSelector = '.product__thumbnails:not(.swiper-initialized)';

window.swiper2 = new Swiper(productThumbnailsSelector, {
    direction: 'horizontal',
    slidesPerView: 'auto',
    spaceBetween: 8,
    speed: 250,
    freeMode: true,
    mousewheel: {
        enabled: true,
        sensitivity: 3,
    },
    watchSlidesProgress: true,
    breakpoints: {
      768: {
        direction: 'vertical',
        spaceBetween: 12,
      }
    }
});

window.swiper = new Swiper(productGallerySelector, {
    slidesPerView: 'auto',
    speed: 500,
    spaceBetween: 6,
    breakpoints: {
        768: {
            slidesPerView: 1,
            spaceBetween: 6
        }
    },
    pagination: {
        el: '.product__gallery-pagination',
    },
    thumbs: {
        swiper: window.swiper2,
    }
});


document.addEventListener("DOMContentLoaded", function () {
    const cta = document.querySelector('.product__cta');
    const ctaSticky = document.querySelector('.product__cta--sticky');
    const stickyClass = 'product__cta--visible';
  
    if (!cta || !ctaSticky) return;
  
    let hasScrolledPastCTA = false;
  
    function checkCTAVisibility() {
      const ctaBottom = cta.getBoundingClientRect().bottom;
  
      if (ctaBottom < 0) {
        // Пользователь уже проскроллил ниже обычной CTA
        hasScrolledPastCTA = true;
      }
  
      if (hasScrolledPastCTA && ctaBottom < 0) {
        ctaSticky.classList.add(stickyClass);
      } else {
        ctaSticky.classList.remove(stickyClass);
      }
    }
  
    window.addEventListener('scroll', checkCTAVisibility);
    window.addEventListener('resize', checkCTAVisibility);
    checkCTAVisibility();
  });